import axios from 'axios';
import { store } from '../app/store';

axios.interceptors.request.use((config) => {
  const state = store.getState();
  const masqueradeUserId = state.masquerade?.userId;

  if (masqueradeUserId) {
    config.headers['X-Masquerade-User'] = masqueradeUserId;
  }

  return config;
});
